<template>
    <div id="token"><span>{{$t("trade.token")}}</span></div>
</template>

<script>
    import api from '@/plugins/api'
    import {mapState} from 'vuex'

    export default {
        name: "Token",
        computed: {
            ...mapState(['user'])
        },
        mounted() {
            //通过token获取用户账号，再跳转
            api.getCacheCustomerByToken(this.$route.query.loginToken).then(res => {
                    if (res.status == 200 && res.data.code == 200) {
                        //获取token成功,保存用户信息，并跳转到对应的页面
                        const user = {
                            loginname: res.data.data.customerNumber,
                            pwd: res.data.data.encryption,
                            companyId: res.data.data.companyId,
                            mobilePhone: res.data.data.mobilePhone,
                            mobilePhonePrefix:res.data.data.mobilePhonePrefix,
                            token:this.$route.query.loginToken,
                            email:res.data.data.email,
                            gts2CustomerId:res.data.data.gts2CustomerId,
                        };
                        this.$store.dispatch("setUser", user);
                        this.$router.replace("/home");//刷新页面，实现socket重连
                    }
                }
            );
        }
    }
</script>

<style scoped>

</style>
